import RecurrenceAvailability from './RecurrenceAvailability';

export default RecurrenceAvailability;
